import { Coach } from '../../../../../../../interfaces/coachList/CoachListInfo';

export const getCoachDescription = (coach: Coach): string => {
  const { gender, age, entityName } = coach;
  const infoParts = [gender, age && `${age} years`].filter(Boolean);

  return infoParts.length ? `${infoParts.join(', ')} | ${entityName}` : entityName;
};
